import * as React from 'react';
import {createRoot} from 'react-dom/client';
import {Root} from "./Root";

const container = document.createElement('div');
document.body.appendChild(container);
const root = createRoot(container);
root.render(
	<Root/>
);
